<template>
    <form :action="action" method="POST" @submit="submitting = true">
        <input type="hidden" name="_token" :value="csrfToken">
        <confirm-tooltip
            v-if="!submitting"
            button-icon="redo"
            button-text="Retry Now"
            button-branding="btn-success-hover"
            confirm-action="premium-server-resume">
            Retry payment for {{ guildName }}?
        </confirm-tooltip>
        <div v-else class="confirm-tooltip__container btn-settings-action btn-success-hover" style="opacity: 0.6; pointer-events: none;">
            <font-awesome-icon icon="circle-notch" :spin="true" class="mr-1"></font-awesome-icon>
            <span>Processing…</span>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            action: { type: String, required: true },
            guildName: { type: String, required: true },
        },
        data() {
            return {
                submitting: false,
                csrfToken: document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '',
            };
        },
    };
</script>
